"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var styles = {
  "anypoint-styles": "styles__anypoint-styles__2EpL2",
  "navlist": "styles__navlist__1CU3Y",
  "list-item": "styles__list-item__3LODM",
  "link": "styles__link__1aKf-",
  "icon": "styles__icon__2p8sb",
  "parent": "styles__parent__3gth8",
  "text-overflow": "styles__text-overflow__1fMNd",
  "anypointStyles": "styles__anypoint-styles__2EpL2",
  "listItem": "styles__list-item__3LODM",
  "textOverflow": "styles__text-overflow__1fMNd"
}; 
require('./styles.css');
var noOp = function noOp() {};
var displayName = 'NavList';
var mainOrgLabel = '- Root -';
var propTypes = {
  /** array of items in the NavList */
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
};
var defaultProps = {
  items: []
};

/* eslint-disable react/prop-types */
var renderContents = function renderContents(item) {
  var titleDisplay = null;
  var text = item.parent;
  if (item.isRoot) {
    text = mainOrgLabel;
  }
  if (text) {
    titleDisplay = /*#__PURE__*/_react["default"].createElement("div", {
      className: "".concat(styles.parent).concat(item.active ? ' popover-if-clicked-ignore-close' : '')
    }, text);
  }
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.textOverflow
  }, titleDisplay, item.name);
};
var renderA = function renderA(item) {
  var linkClasses = "".concat(styles.link, " ").concat(item.active ? styles.active : '');
  var title = item.name && item.name.length > 35 ? item.name : null;
  var link = item.href || null;
  var linkTarget = item.target || null;
  var itemIcon = item.icon ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: styles.icon,
    name: item.icon,
    size: ""
  }) : null;
  return /*#__PURE__*/_react["default"].createElement("a", {
    className: linkClasses,
    title: title,
    href: link,
    target: linkTarget
  }, itemIcon, renderContents(item));
};
/* eslint-enable react/prop-types */

var renderItem = function renderItem(item, index) {
  var handleClick = item.onClick || noOp;
  var listClass = item.active ? "".concat(styles.active, " popover-if-clicked-ignore-close") : '';
  var listTestId = "navbar-list-item-".concat(item.name ? item.name.replace(/ /g, '-') : index);
  var keyItem = "navbar-list-item-".concat(index);
  var listClasses = "".concat(styles.listItem, " ").concat(listClass);
  return /*#__PURE__*/_react["default"].createElement("li", {
    className: listClasses,
    "data-org": item.orgId,
    "data-test-id": listTestId,
    key: keyItem,
    onClick: handleClick,
    role: "presentation"
  }, renderA(item));
};
var NavList = function NavList(_ref) {
  var items = _ref.items;
  if (!items || items.length === 0) {
    // List empty
    return false;
  }
  var renderItems = items.map(function (item, i) {
    return renderItem(item, i);
  });
  return /*#__PURE__*/_react["default"].createElement("ul", {
    className: styles.navlist
  }, renderItems);
};
NavList.displayName = displayName;
NavList.propTypes = propTypes;
NavList.defaultProps = defaultProps;
var _default = exports["default"] = NavList;
//# sourceMappingURL=NavList.js.map